<template style="height: 100%;">
  <div class="CommonContentSingle-gray">
    <el-container>
      <el-header>
        <el-form :inline="true" :model="from" class="demo-form-inline">
          <el-form-item label="账号搜索">
            <el-input v-model="from.UserID" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="姓名搜索">
            <el-input v-model="from.UserName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chaxun">查询</el-button>
          </el-form-item>
        </el-form>
      </el-header>


      <el-main>
        <el-descriptions class="margin-top" title="用户信息" :column="3" border>
          <template slot="extra">
            <el-button type="primary" size="small" @click="tianjia">添加权限</el-button>
          </template>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-user"></i> 用户名</template>
            {{ RealName }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-tickets"></i> 账号</template>
            账号
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-tickets"></i> 状态</template>
            {{ IsAuthorized }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-user-solid"></i> 地址</template>
            {{ Address }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-mobile-phone"></i> 手机号</template>
            {{ Phone }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-mobile-phone"></i> 身份证号</template>
            {{ IDCard }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-s-opportunity"></i> 性别</template>
            {{ Sex }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-s-opportunity"></i> 年龄</template>
            {{ Age }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-tickets"></i> 备注</template>
            备创
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-date"></i> 创建日期</template>
            {{ CreatedDate }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"><i class="el-icon-date"></i> 出生日期</template>
            {{ Birthday }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label"> <i class="el-icon-office-building"></i> 开始至结束时间</template>
            <el-date-picker v-model="value1" unlink-panels type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-descriptions-item>

        </el-descriptions>
      </el-main>
    </el-container>
  </div>
</template>
<script>

export default {
  data() {
    return {
      RealName: '',
      Address: '',
      CreatedDate: '',
      Birthday: '',
      IsAuthorized: '',
      IDCard: '',
      Age: '',
      Phone: '',
      Sex: '',
      value1: '1',
      group: '',
      wloadings: true,
      tableData: '',
      pageIndexs: 1,
      from: {
        UserID: '',
        UserName: '',
      },
    }
  },

  components: {

  },

  methods: {
    chaxun() {//查询
      this.$Http_Post('Publicity/GetForeignAuthorizedUser', { "UserID": this.from.UserID, "UserName": this.from.UserName }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data[0];
          this.RealName = this.tableData.a.RealName;
          if (this.tableData.a.Address) { this.Address = this.tableData.a.Address; } else { this.Address = "未输入" }
          if (this.tableData.a.Birthday) { this.Birthday = this.tableData.a.Birthday; } else { this.Birthday = "未输入" }
          if (this.tableData.a.Phone) { this.Phone = this.tableData.a.Phone; } else { this.Phone = "未输入" }
          if (this.tableData.a.Age) { this.Age = this.tableData.a.Age; } else { this.Age = "未输入" }
          if (this.tableData.a.Sex) { this.Sex = this.tableData.a.Sex; } else { this.Sex = "未输入" }
          if (this.tableData.a.CreatedDate) { this.CreatedDate = this.tableData.a.CreatedDate; } else { this.CreatedDate = "未输入" }
          if (this.tableData.a.IDCard) { this.IDCard = this.tableData.a.IDCard; } else { this.IDCard = "未输入" }
          if (this.tableData.IsAuthorized) { this.IsAuthorized = this.tableData.IsAuthorized; } else { this.IsAuthorized = "未输入" }
        } else {
          this.wloadings = false;
        }
      },)
    },

    tianjia() {
    },

    loading() {
      var dataForm = {
        pageSize: 10,
        pageIndex: 0,
        DropKeyType: "WorkGroup",
      }
      this.$Http_Post('workingtime/getdropdownkeylist', dataForm).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.wloadings = false;
          this.totalnumber = res.Counts;
        } else {
          this.wloadings = false;
        }
      },)
    },
  },
  watch: {

  },
  mounted() {
    this.loading();
  }
}

</script>

<style>

</style>